import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

interface IOption {
    id: number;
    name: string;
}

@Component({
    selector: 'app-custom-single-selector-editor',
    templateUrl: './custom-single-selector-editor.component.html',
    styleUrls: ['./custom-single-selector-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent, ValidationErrorMessageComponent]
})
export class CustomSingleSelectorEditorComponent extends EditorComponentBase<string | null> implements OnInit {
    source?: IOption[];
    selectedItem?: IOption;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        if (this.additionalInfo.options) {
            this.source = this.toIOptionFormat(this.additionalInfo.options);
        }
        if (this.bindingProperty) this.selectedItem = this.toIOptionFormat([this.bindingProperty])[0];
    }

    onSelectedItemChange() {
        if (this.selectedItem?.name) {
            this.bindingProperty = this.selectedItem.name;
            this.validate();
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    private toIOptionFormat(options: string[]) {
        return options.map((option) => ({ id: 0, name: option }));
    }
}
